import React from "react";
import "../styles.css";
const Next = props => {
  return (
    <div className="next">
      <button onClick={props.onClick}>&#10095;</button>
    </div>
  );
};
export default Next;
